import { css } from 'styled-components';

const CompleteTheLookStyle = css`
  /* stylelint-disable max-nesting-depth */
  &.slider-icon-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: end;
    position: absolute;
    bottom: 0px;
    right: 0px;
    border-radius: 50px;
    background-color: ${(props) => props.theme.colors.WHITE};
    box-shadow: 0 5px 12px 0 rgba(0, 0, 0, 0.12);
    cursor: pointer;
    /* stylelint-disable no-descending-specificity*/
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      padding: 12px 12px 12px 21px;
      width: 139px;
      animation: animate-slide-out 0.5s ease-in 3s forwards;
      background-color: ${(props) => props.theme.colors.TRANSLUCENT_BG_COLOR};
    }
    @media ${(props) => props.theme.mediaQuery.medium} {
      padding: 12px;
      width: 20px;
      &:hover {
        animation: animate-slide-in 0.5s forwards;
        padding: 12px 12px 12px 21px;
        width: 20px;
        background-color: ${(props) => props.theme.colors.TRANSLUCENT_BG_COLOR};
        .icon-text {
          display: block;
          max-width: 103px;
        }
      }
    }
  }
  &.disable-animation {
    @media ${(props) => props.theme.mediaQuery.medium} {
      animation: animate-slide-in 0.5s forwards;
      padding: 12px 12px 12px 21px;
      width: 139px;
      background-color: ${(props) => props.theme.colors.TRANSLUCENT_BG_COLOR};
      .icon-text {
        display: block;
        max-width: 103px;
      }
    }
  }
  .icon-text {
    color: ${(props) => props.theme.colors.BLACK};

    white-space: nowrap;
    overflow: hidden;
    z-index: 1;
    font-size: 14px;
    font-weight: 800;
    ${(props) => (props.reverseOrder ? 'order:1' : 'order:0')};
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      min-width: 0px;
      -webkit-transition: min-width 0.5s;
      transition: min-width 0.5s;
      transition-delay: 2s;
    }
    @media ${(props) => props.theme.mediaQuery.medium} {
      max-width: 0;
      -webkit-transition: max-width 0.5s;
      transition: max-width 0.5s;
    }
  }

  #discoveryIcon,
  .discovery-icon {
    width: 20px;
    height: 20px;
    position: relative;
  }
  @keyframes animate-slide-in {
    0% {
      width: 20px;
    }
    100% {
      width: 136px;
    }
  }

  @keyframes animate-slide-out {
    0% {
      width: 136px;
    }
    100% {
      width: 20px;
      padding: 12px;
    }
  }
`;

export default CompleteTheLookStyle;
